import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CompanyCard from "../Components/Company/CompanyCard";
import searchSlice from "../features/search/search-slice";
import axios from "axios";

function TopX() {
  const dispatch = useDispatch();

  const numberKW = useSelector((state) => state.search.numberKW);
  const globalLoading = useSelector((state) => state.search.globalLoading);

  const [topCompanies, setTopCompanies] = useState([]);

  useEffect(() => {
    dispatch(searchSlice.actions.setPageNo(1));
    document.title = "SupPer - Top X";

    dispatch(searchSlice.actions.setGlobalLoading(true));

    axios
      .post(process.env.REACT_APP_BACKEND_URL + `/numberSearch`, {
        No_of_Companies: numberKW,
      })
      .then((response) => {
        console.log(response.data);
        setTopCompanies(response.data.List_of_Companies);
      })
      .catch((error) => {
        console.log(error.message);
      })
      .finally(() => {
        dispatch(searchSlice.actions.setGlobalLoading(false));
      });
  }, []);

  return (
    <div className="flex flex-col h-full mt-4 gap-2 mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
      {numberKW && (
        <div className="text-3xl text-white font-bold w-full text-center">
          Top <span className="text-blue-500">{numberKW}</span> Companies
        </div>
      )}

      <div className="flex items-center w-full p-4 border-2 border-gray-600 rounded-md bg-white">
        {/* {!globalLoading && !industryKW.value && !companyKW.value && (
          <div className="flex flex-col gap-4 w-full bg-gray-50 items-center border-2 border-red-500">
            <div className="font-bold text-indigo-600 text-xl  md:text-3xl mt-32 md:mt-16">
              Please make a search to see results !
            </div>
            <img
              src="https://cdn.dribbble.com/users/1785628/screenshots/5605512/media/097297f8e21d501ba45d7ce437ed77bd.gif"
              className="w-full md:w-1/2"
            />
          </div>
        )} */}
        {globalLoading && (
          <img
            src="https://i.pinimg.com/originals/b0/45/af/b045af8a94343e3b1fdbf1576e9818b8.gif"
            className="w-1/3 mx-auto"
          />
        )}

        {!globalLoading && (
          <div className="flex flex-wrap justify-around  w-full  p-2 md:p-4">
            {topCompanies?.map((s) => {
              return <CompanyCard supplier={s} key={s.Cost} />;
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default TopX;
